import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-sm text-catering-ink-700" }
const _hoisted_3 = {
  key: 0,
  class: "mb-1 text-sm text-catering-ink-500"
}
const _hoisted_4 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_5 = { class: "min-w-0 truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-catering-berry-500"
}
const _hoisted_7 = {
  key: 1,
  class: "text-catering-ink-400"
}
const _hoisted_8 = { class: "shrink-0 tabular-nums" }
const _hoisted_9 = {
  key: 1,
  class: "mt-2 flex flex-wrap gap-1"
}


export default {
  __name: 'BotProductList',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Products", -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.block.count) + " " + _toDisplayString(__props.block.count === 1 ? 'product' : 'products') + " in your catalog ", 1),
    (__props.block.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.block.note), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.products || [], (p, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass(["flex items-center justify-between py-1.5 text-sm", p.status === 'live' ? 'text-catering-ink-900' : 'text-catering-ink-400'])
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(p.name) + " ", 1),
            (p.status && p.status !== 'live')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "· " + _toDisplayString(p.status), 1))
              : (p.inventory !== 'unlimited')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "· " + _toDisplayString(p.inventory) + " left", 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(p.price), 1)
        ], 2))
      }), 128))
    ]),
    ((__props.block.by_store || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.by_store, (s, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
            }, _toDisplayString(s.store) + ": " + _toDisplayString(s.product_count), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}